/**
 * Created by 侯上帅 on 2019/1/25
 */
import CryptoJS from 'crypto-js'

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string') time = parseInt(time)
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  return format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') {
      return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
}

/**
 * 获取当前时间或当天开始时间
 * @param {string} type
 */
export function getTime(type) {
  return new Date(new Date().toDateString())
}

// create uuid
export function uuid() {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }

  return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4()
}

/**
 * 签名
 * 规则：MD5(params+xxx + token+xxx + timestamp+xxx + traceid+xxx)
 */
export function signature(params, keys) {
  let str = ''
  keys.forEach((key, i) => {
    let value = params[key]
    str += `${key}${value}`
  })
  str = CryptoJS.MD5(str).toString()
  return str
}

/**
 * MD5加密
 */
export function MD5(str) {
  return CryptoJS.MD5(str).toString()
}
/**
 * 验证签名
 * @returns {Boolean} 验证结果 成功-true 失败-false
 */
export function verifySign(params, keys) {
  let sign = signature(params, keys)
  return sign === params.sign
}

// 获取参数值
export function getQueryParam(name) {
  let reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i')
  let result = window.location.search.substr(1).match(reg)
  if (result != null) {
    return decodeURI(result[2])
  }
  return null
}

/**
 * 日期格式化
 * @param {*} date Date 对象
 * @param {*} fmt 格式 yyyy-MM-dd hh:mm:ss
 */
export function dateFormat(date, fmt) {
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    S: date.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}

// 保留两位小数（钱）
export function ToDubble(num, isMoney) {
  let a = 0
  if (num < 0) {
    a = 1
  }

  num += ''
  num = num.replace(/[^0-9|\\.]/g, '') // 清除字符串中的非数字非.字符

  if (/^0+/.test(num)) {
    num = num.replace(/^0+/, '')
  }
  if (!/\./.test(num)) {
    num += '.00'
  }
  if (/^\./.test(num)) {
    num = '0' + num
  }
  num += '00'
  if (isMoney) {
    num = (Math.ceil(Math.round(num * 10000) / 100) / 100).toFixed(2)
  } else {
    num = (num * 100 / 100).toFixed(2)

  }
  if (a == 1) {
    num = -num
  }
  // num = num.match(/\d+\.\d{2}/)[0]
  return num
}

/**
 * 时间戳转日期
 */
export function formatDate(timestamp) {
  var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '/';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/';
  var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
  var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
  var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
  return Y + M + D + h + m + s;
}
/**
 *  加入缓存 xwp Create 2019-04-24
 */
export function putStore(key, val, time) {
  storage(key, val);
  var seconds = parseInt(time);
  if (seconds > 0) {
    var timestamp = Date.parse(new Date());
    timestamp = timestamp / 1000 + seconds;
    localStorage.setItem(key + "dtime", timestamp + "");
  } else {
    localStorage.setItem(key + "dtime", "");
  }
}
/**
 * 读取缓存 xwp Create 2019-04-24
 */
export function getStore(key, def) {
  var deadtime = parseInt(localStorage.getItem(key + "dtime"));
  if (deadtime) {
    if (parseInt(deadtime) < Date.parse(new Date()) / 1000) {
      if (def) {
        return def;
      } else {
        return;
      }
    }
  }
  var res = storage(key);
  if (res) {
    return res;
  } else {
    return def;
  }
}

/**
 * 节流函数 xwp Create 2019-05-24
 */
export function debounce(fn, wait, timeout) {
  if (timeout !== null) clearTimeout(timeout)
  timeout = setTimeout(fn, wait)
}
//将浮点数四舍五入，取小数点后2位  xwp_CREATE
export function toDecimal(x) {
  var f = parseFloat(x);
  if (isNaN(f)) {
    return;
  }
  f = Math.round(x * 100) / 100;
  return f;
}
// 计算获取时间戳-毫秒 xwp_CREATE
export function getTimerSecoed(dateStr) {
  if (!dateStr) {
    return ''
  }
  let newDataStr = dateStr.replace(/\.|\-/g, '/')
  let date = new Date(newDataStr);
  let timestamp = date.getTime();
  return timestamp
}
//计算日期相隔天数
export function DateDiff(sDate1, sDate2) { //sDate1和sDate2是2019-3-12格式
  let startTamp = new Date(sDate1).getTime();
  let endTamp = new Date(sDate2).getTime();
  let chatT = endTamp - startTamp;
  let iDays = Math.floor(chatT / 86400000);
  return iDays
}

//节流函数 --lyy
export function throttle(fn, gapTime) {
  if (gapTime == null || gapTime == undefined) {
    gapTime = 1500
  }
  let _lastTime = null
  // 返回新的函数
  return function () {
    let _nowTime = +new Date()
    if (_nowTime - _lastTime > gapTime || !_lastTime) {
      fn.apply(this, arguments) //将this和参数传给原函数
      _lastTime = _nowTime
    }
  }
}

/*获取当前页带参数的url*/
export function getCurrentPageUrlWithArgs(pageObj) {
  var url = pageObj.route //当前页面url
  var options = pageObj.options //如果要获取url中所带的参数可以查看options

  //拼接url的参数
  var urlWithArgs = url + '?'
  for (var key in options) {
    var value = options[key]
    urlWithArgs += key + '=' + value + '&'
  }
  urlWithArgs = urlWithArgs.substring(0, urlWithArgs.length - 1)

  return urlWithArgs
}

//localStorage
export const storage = (key, value) => {
  if (value) {
    localStorage.setItem(key, JSON.stringify(value))
  } else {
    const item = localStorage.getItem(key)
    return item ? JSON.parse(item) : undefined
  }
}

//获取连接参数
export function getQueryVariable() {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  var obj = {};
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    obj.pair[0] = pair[1];
  }
  return obj;
}

//获取连接参数
export function getQueryObject(url = window.location.href) {
  var query = url.substring(url.indexOf('?') + 1);
  var vars = query.split("&");
  var obj = {};
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    obj[pair[0]] = pair[1];
  }
  return obj;
}

//获取连续工作日
export function getWeeks(arr) {
  var newArr = [], str = '';
  if (arr && arr.length > 0) {
    arr.forEach(res => {
      newArr.push(week(res))
    });
  }
  str = newArr.length > 0 ? newArr.join(',') : ''
  return str;
}

//获取星期几
export function week(num) {
  var str = ''
  switch (num) {
    case 0:
      str = '星期日';
      break;
    case 1:
      str = '星期一';
      break;
    case 2:
      str = '星期二';
      break;
    case 3:
      str = '星期三';
      break;
    case 4:
      str = '星期四';
      break;
    case 5:
      str = '星期五';
      break;
    case 6:
      str = '星期六';
      break;
  }
  return str;
}


var regYear = new RegExp("(y+)", "i");

export function formatTime(i, timestamp, format) {
  if (!format) {
    format = "yyyy-MM-dd hh:mm:ss";
  }
  var realDate = getLocalTime(i, timestamp);
  function timeFormat(num) {
    return num < 10 ? '0' + num : num;
  }
  var date = [
    ["M+", timeFormat(realDate.getMonth() + 1)],
    ["d+", timeFormat(realDate.getDate())],
    ["h+", timeFormat(realDate.getHours())],
    ["m+", timeFormat(realDate.getMinutes())],
    ["s+", timeFormat(realDate.getSeconds())],
    ["q+", Math.floor((realDate.getMonth() + 3) / 3)],
    ["S+", realDate.getMilliseconds()],
  ];
  var reg1 = regYear.exec(format);
  // console.log(reg1[0]);
  if (reg1) {

    format = format.replace(reg1[1], (realDate.getFullYear() + '').substring(4 - reg1[1].length));
  }
  for (var i = 0; i < date.length; i++) {
    var k = date[i][0];
    var v = date[i][1];

    var reg2 = new RegExp("(" + k + ")").exec(format);
    if (reg2) {
      format = format.replace(reg2[1], reg2[1].length == 1
        ? v : ("00" + v).substring(("" + v).length));
    }
  }
  return format;
}
function getLocalTime(i, time) {

  if (typeof i !== 'number') return;

  var d = new Date();

  var len = new Date(time).getTime();

  var offset = d.getTimezoneOffset();

  // var utcTime = len - offset;

  return new Date(len + offset * 60 * 1000 + 8 * 60 * 60 * 1000);

}
